
<div class="checkbox checkbox-dark m-squar">
    <input 
    id="{{dyanamicId?dyanamicId:checkBoxLabel}}" 
    name="name" 
    type="checkbox"
    [required]="isRequired" 
    [disabled]="disabled"
    [(ngModel)]="status"
    (click)="check.emit($event.target.checked)"
    >
    <label 
    [class]="'mt-0 '+ checkBoxClass" 
    for="{{dyanamicId?dyanamicId:lableName}}" 
    *ngIf="checkBoxLabel"
    >
    {{checkBoxLabel}}
    </label>
</div>